import { getBirdviewAttention } from '../../../../api'
import { getBirdviewAttentionParams } from '../../DashboardBirdview.utils.api'
import { useBirdviewRequestLoaders } from '../useBirdviewRequestLoaders'

import {
  getBirdviewAttentionRequestRows,
  toBirdviewAttentionSection,
} from './useBirdviewAttentionLoaders.utils'

export function useBirdviewAttentionLoaders() {
  const { getRequestsExtra } = useBirdviewRequestLoaders()

  async function getAttentionSection(params) {
    const { data } = await getBirdviewAttention(
      getBirdviewAttentionParams(params)
    )

    return toBirdviewAttentionSection({
      data,
      extra: await getRequestsExtra(
        getBirdviewAttentionRequestRows(data.items)
      ),
    })
  }

  return { getAttentionSection }
}
